export interface TVShow {
  id: string;
  title: string;
  subTitle: string;
  coverImage: string;
  rating: number;
  year: number;
  category: string;
  categorySlug: string;
  region: string;
  episodeCount: number;
  currentEpisode: number;
  status: 'hot' | 'completed' | 'updating';
  description: string;
  director: string;
  cast: string[];
  updateInfo: string;
  tags: string[];
}

export interface TVCategory {
  name: string;
  slug: string;
  icon: string;
  count: number;
}

export const categories: TVCategory[] = [
  { name: '全部', slug: 'all', icon: 'ri-tv-line', count: 156 },
  { name: '古装剧', slug: 'costume', icon: 'ri-ancient-gate-line', count: 42 },
  { name: '都市剧', slug: 'urban', icon: 'ri-building-line', count: 38 },
  { name: '悬疑剧', slug: 'suspense', icon: 'ri-search-eye-line', count: 28 },
  { name: '甜宠剧', slug: 'romance', icon: 'ri-heart-line', count: 24 },
  { name: '谍战剧', slug: 'spy', icon: 'ri-spy-line', count: 18 },
  { name: '喜剧', slug: 'comedy', icon: 'ri-emotion-laugh-line', count: 16 },
  { name: '奇幻剧', slug: 'fantasy', icon: 'ri-magic-line', count: 14 },
];

export const tvShows: TVShow[] = [
  {
    id: 'chang-xiang-si-2',
    title: '长相思 第二季',
    subTitle: '杨紫张晚意再续仙侠虐恋',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20costume%20fantasy%20drama%20poster%20featuring%20elegant%20ancient%20Chinese%20figures%20in%20flowing%20traditional%20hanfu%20robes%20against%20misty%20mountains%20and%20dreamy%20celestial%20backdrop%20warm%20golden%20and%20crimson%20tones%20cinematic%20composition%20with%20soft%20ethereal%20lighting&width=600&height=800&seq=show-cover-01&orientation=portrait',
    rating: 9.2,
    year: 2024,
    category: '古装剧',
    categorySlug: 'costume',
    region: '中国大陆',
    episodeCount: 40,
    currentEpisode: 32,
    status: 'updating',
    description: '《长相思》第二季延续第一季的故事，讲述了大荒世界中的爱恨情仇。小夭（杨紫饰）与玱玹（张晚意饰）、涂山璟（邓为饰）、相柳（檀健次饰）之间的情感纠葛进一步升级，在这场命运的考验中，每个人都将面临自己的抉择。本剧改编自桐华同名小说，以宏大的世界观、精致的服化道和演员精湛的演技获得了观众的广泛好评。',
    director: '秦榛',
    cast: ['杨紫', '张晚意', '邓为', '檀健次', '王弘毅'],
    updateInfo: '每周一至周五更新2集',
    tags: ['仙侠', '虐恋', '古装', '玄幻', 'IP改编'],
  },
  {
    id: 'qing-yu-nian-2',
    title: '庆余年 第二季',
    subTitle: '张若昀领衔权谋大戏回归',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20with%20a%20mysterious%20male%20protagonist%20in%20dark%20ornate%20traditional%20official%20robes%20standing%20in%20front%20of%20an%20ancient%20palace%20courtyard%20dramatic%20lighting%20with%20deep%20shadows%20and%20golden%20highlights%20epic%20cinematic%20movie%20poster%20style&width=600&height=800&seq=show-cover-02&orientation=portrait',
    rating: 9.5,
    year: 2024,
    category: '古装剧',
    categorySlug: 'costume',
    region: '中国大陆',
    episodeCount: 36,
    currentEpisode: 36,
    status: 'completed',
    description: '《庆余年》第二季讲述了范闲（张若昀饰）在经历了一系列考验后，继续在庆国朝堂中运筹帷幄的故事。本季剧情更加紧凑，权谋斗争升级，范闲的身世之谜也逐渐揭开。作为一部现象级古装权谋剧，本季在制作规模、演员阵容和剧情深度上都达到了新的高度。',
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    updateInfo: '已完结',
    tags: ['权谋', '古装', '喜剧', 'IP改编', '口碑剧'],
  },
  {
    id: 'fan-hua',
    title: '繁花',
    subTitle: '王家卫首部电视剧 胡歌主演',
    coverImage: 'https://readdy.ai/api/search-image?query=Retro%20Shanghai%201990s%20drama%20poster%20with%20a%20stylish%20man%20in%20vintage%20suit%20walking%20along%20neon-lit%20Nanjing%20Road%20at%20night%20golden%20warm%20tones%20nostalgic%20atmosphere%20Wong%20Kar-wai%20aesthetic%20cinematic%20framing&width=600&height=800&seq=show-cover-03&orientation=portrait',
    rating: 9.4,
    year: 2024,
    category: '都市剧',
    categorySlug: 'urban',
    region: '中国大陆',
    episodeCount: 30,
    currentEpisode: 30,
    status: 'completed',
    description: '《繁花》是导演王家卫的首部电视剧作品，改编自金宇澄同名小说。故事以上世纪九十年代的上海为背景，讲述了阿宝（胡歌饰）在商海沉浮中的传奇人生。该剧以独特的视觉风格和电影级质感，展现了上海这座城市的繁华与变迁，被誉为"中国电视剧的审美天花板"。',
    director: '王家卫',
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    updateInfo: '已完结',
    tags: ['年代剧', '商战', '上海', '王家卫', '口碑剧'],
  },
  {
    id: 'kuang-biao',
    title: '狂飙',
    subTitle: '张译张颂文演技巅峰对决',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20poster%20with%20intense%20atmosphere%20showing%20a%20determined%20police%20officer%20facing%20a%20shadowy%20powerful%20figure%20dramatic%20contrast%20lighting%20dark%20urban%20setting%20tension-filled%20cinematic%20composition&width=600&height=800&seq=show-cover-04&orientation=portrait',
    rating: 9.6,
    year: 2023,
    category: '悬疑剧',
    categorySlug: 'suspense',
    region: '中国大陆',
    episodeCount: 39,
    currentEpisode: 39,
    status: 'completed',
    description: '《狂飙》是一部以扫黑除恶为主题的刑侦剧，讲述了刑警安欣（张译饰）与黑恶势力头目高启强（张颂文饰）长达二十年的正邪较量。该剧以扎实的剧本、鲜活的人物塑造和演员教科书级别的表演，成为近年来最具影响力的国产电视剧之一。',
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '张志坚', '吴刚'],
    updateInfo: '已完结',
    tags: ['刑侦', '扫黑', '犯罪', '演技派', '现象级'],
  },
  {
    id: 'yu-feng-xing',
    title: '与凤行',
    subTitle: '赵丽颖林更新仙侠甜宠',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20romance%20drama%20poster%20with%20beautiful%20female%20immortal%20and%20handsome%20male%20deity%20floating%20among%20cherry%20blossoms%20and%20celestial%20clouds%20soft%20pink%20and%20lavender%20tones%20dreamy%20romantic%20atmosphere&width=600&height=800&seq=show-cover-05&orientation=portrait',
    rating: 8.9,
    year: 2024,
    category: '甜宠剧',
    categorySlug: 'romance',
    region: '中国大陆',
    episodeCount: 39,
    currentEpisode: 39,
    status: 'completed',
    description: '《与凤行》改编自九鹭非香小说，讲述了碧苍王沈璃（赵丽颖饰）与上古神行止（林更新饰）之间跨越三界的绝美仙侠爱情故事。该剧以精美的特效、甜虐交织的剧情和主演之间强烈的化学反应，赢得了观众的喜爱。',
    director: '邓科',
    cast: ['赵丽颖', '林更新', '辛云来', '何与'],
    updateInfo: '已完结',
    tags: ['仙侠', '甜宠', '古装', 'IP改编'],
  },
  {
    id: 'mo-ren-you-xi',
    title: '默人游戏',
    subTitle: '张新成周雨彤悬疑烧脑',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20psychological%20thriller%20drama%20poster%20with%20mysterious%20chess%20pieces%20and%20a%20maze-like%20pattern%20dark%20blue%20and%20black%20tones%20intense%20mysterious%20atmosphere%20a%20man%20and%20woman%20looking%20at%20each%20other%20with%20suspicion%20cinematic%20noir%20style&width=600&height=800&seq=show-cover-06&orientation=portrait',
    rating: 8.7,
    year: 2024,
    category: '悬疑剧',
    categorySlug: 'suspense',
    region: '中国大陆',
    episodeCount: 24,
    currentEpisode: 18,
    status: 'updating',
    description: '《默人游戏》是一部心理悬疑剧，讲述了一群人在一场神秘游戏中逐渐揭开真相的故事。每个角色都隐藏着不为人知的秘密，随着剧情推进，真相愈发扑朔迷离。该剧以紧凑的叙事节奏和出人意料的剧情反转，让观众欲罢不能。',
    director: '王伟',
    cast: ['张新成', '周雨彤', '王骁', '刘奕君'],
    updateInfo: '每周三至周六更新2集',
    tags: ['悬疑', '心理', '推理', '烧脑'],
  },
  {
    id: 'cheng-feng-ta-lang',
    title: '乘风踏浪',
    subTitle: '彭昱畅乔杉创业喜剧',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20workplace%20comedy%20drama%20poster%20with%20two%20contrasting%20male%20leads%20one%20young%20and%20one%20middle-aged%20standing%20together%20in%20a%20modern%20startup%20office%20bright%20warm%20lighting%20professional%20yet%20humorous%20atmosphere&width=600&height=800&seq=show-cover-07&orientation=portrait',
    rating: 8.5,
    year: 2024,
    category: '喜剧',
    categorySlug: 'comedy',
    region: '中国大陆',
    episodeCount: 35,
    currentEpisode: 35,
    status: 'completed',
    description: '《乘风踏浪》是一部创业题材的都市喜剧，讲述了两个性格迥异的人合伙创业的爆笑故事。彭昱畅饰演的年轻创业者与乔杉饰演的资深销售，从互相看不顺眼到成为最佳搭档，一路披荆斩棘、笑料百出。',
    director: '张挺',
    cast: ['彭昱畅', '乔杉', '卜冠今', '刘佳'],
    updateInfo: '已完结',
    tags: ['喜剧', '创业', '都市', '温情'],
  },
  {
    id: 'qian-qiu-ling',
    title: '千秋令',
    subTitle: '张彬彬景甜领衔主演',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20epic%20fantasy%20wuxia%20drama%20poster%20with%20swordsman%20and%20swordswoman%20posing%20dramatically%20in%20ancient%20battlefield%20silhouette%20against%20blood-red%20sunset%20sky%20flowing%20costumes%20and%20swirling%20energy%20effects&width=600&height=800&seq=show-cover-08&orientation=portrait',
    rating: 8.3,
    year: 2024,
    category: '奇幻剧',
    categorySlug: 'fantasy',
    region: '中国大陆',
    episodeCount: 42,
    currentEpisode: 25,
    status: 'updating',
    description: '《千秋令》是一部宏大的奇幻武侠剧，讲述了一段跨越千年的宿命之战。正邪对立、爱恨纠葛，一群少年在乱世中成长，守护心中的正义。该剧以精美的特效场景和热血的动作设计，打造了一个令人沉浸的东方奇幻世界。',
    director: '赵锦焘',
    cast: ['张彬彬', '景甜', '许凯', '袁冰妍'],
    updateInfo: '每周一至周五更新2集',
    tags: ['武侠', '奇幻', '古装', '热血'],
  },
  {
    id: 'wang-pai-bu-dui',
    title: '王牌部队',
    subTitle: '肖战黄景瑜军旅热血',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20military%20drama%20poster%20with%20soldiers%20in%20modern%20camouflage%20uniforms%20standing%20at%20attention%20against%20national%20flag%20background%20heroic%20and%20patriotic%20atmosphere%20golden%20sunlight%20serious%20determined%20expressions&width=600&height=800&seq=show-cover-09&orientation=portrait',
    rating: 8.8,
    year: 2023,
    category: '都市剧',
    categorySlug: 'urban',
    region: '中国大陆',
    episodeCount: 40,
    currentEpisode: 40,
    status: 'completed',
    description: '《王牌部队》以中国人民解放军某部王牌部队为背景，讲述了高粱（黄景瑜饰）和顾一野（肖战饰）等一群热血青年在部队大熔炉中锻炼成长的感人故事。该剧真实展现了现代军人的精神风貌和家国情怀。',
    director: '刘岩',
    cast: ['肖战', '黄景瑜', '钟楚曦', '李幼斌'],
    updateInfo: '已完结',
    tags: ['军旅', '热血', '成长', '爱国'],
  },
  {
    id: 'xing-han-can-lan',
    title: '星汉灿烂',
    subTitle: '吴磊赵露思古装权谋',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20romance%20drama%20poster%20with%20elegant%20young%20man%20and%20woman%20in%20luxurious%20hanfu%20standing%20under%20starry%20night%20sky%20ancient%20palace%20towers%20in%20background%20warm%20amber%20lantern%20light%20romantic%20atmosphere&width=600&height=800&seq=show-cover-10&orientation=portrait',
    rating: 9.0,
    year: 2022,
    category: '古装剧',
    categorySlug: 'costume',
    region: '中国大陆',
    episodeCount: 56,
    currentEpisode: 56,
    status: 'completed',
    description: '《星汉灿烂》讲述了程少商（赵露思饰）与凌不疑（吴磊饰）在家国天下的大背景下，从相识到相知、相爱的动人故事。该剧以宏大的叙事格局、精良的制作水准和演员出色的表演，成为年度爆款古装剧。',
    director: '费振翔',
    cast: ['吴磊', '赵露思', '郭涛', '曾黎', '保剑锋'],
    updateInfo: '已完结',
    tags: ['古装', '权谋', '爱情', '成长', 'IP改编'],
  },
  {
    id: 'di-yu-bian-jing',
    title: '谍域边境',
    subTitle: '朱一龙王凯双雄对决',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20spy%20thriller%20drama%20poster%20with%20two%20men%20in%201940s%20trench%20coats%20and%20fedora%20hats%20standing%20in%20shadowy%20rainy%20street%20vintage%20noir%20atmosphere%20muted%20gray%20tones%20tension%20and%20intrigue&width=600&height=800&seq=show-cover-11&orientation=portrait',
    rating: 9.1,
    year: 2024,
    category: '谍战剧',
    categorySlug: 'spy',
    region: '中国大陆',
    episodeCount: 42,
    currentEpisode: 20,
    status: 'updating',
    description: '《谍域边境》以抗日战争时期为背景，讲述了代号"暗影"的地下党员与日军情报机关斗智斗勇的故事。朱一龙饰演的潜伏者与王凯饰演的特务处长之间的双雄对决，堪称本剧最大看点。',
    director: '徐兵',
    cast: ['朱一龙', '王凯', '宋轶', '王劲松'],
    updateInfo: '每周一至周五更新2集',
    tags: ['谍战', '抗日', '悬疑', '双男主'],
  },
  {
    id: 'wo-men-de-fan-hua',
    title: '我们的繁花',
    subTitle: '杨幂许凯都市爱情',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20urban%20romance%20drama%20poster%20with%20fashionable%20woman%20and%20handsome%20man%20walking%20through%20bustling%20city%20street%20at%20golden%20hour%20warm%20sunlight%20filtering%20through%20buildings%20romantic%20and%20sophisticated%20atmosphere&width=600&height=800&seq=show-cover-12&orientation=portrait',
    rating: 8.4,
    year: 2024,
    category: '甜宠剧',
    categorySlug: 'romance',
    region: '中国大陆',
    episodeCount: 32,
    currentEpisode: 32,
    status: 'completed',
    description: '《我们的繁花》讲述了一对都市男女在大城市打拼中相遇相知的浪漫爱情故事。杨幂饰演的职场精英与许凯饰演的创业青年，在繁花似锦的都市中寻找属于自己的幸福。',
    director: '林玉芬',
    cast: ['杨幂', '许凯', '高伟光', '祝绪丹'],
    updateInfo: '已完结',
    tags: ['都市', '爱情', '职场', '甜宠'],
  },
];